import {
  ServiceAccountsApi,
  CreateServiceAccountRequest,
  CreateServiceAccountResponse,
  UpsertServiceAccountRequest,
  UpsertServiceAccountResponse,
  DeleteServiceAccountRequest,
  VerifyServiceAccountRequest,
} from './api/ServiceAccountsApi';
import { DiscoveryApi, FetchApi } from '@mainstage/core-plugin-api';
import { handleFailedResponse } from '@agilelab/plugin-wb-platform-common';

export class ServiceAccountsClient implements ServiceAccountsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('catalog');
  }

  async createServiceAccount(
    request: CreateServiceAccountRequest,
  ): Promise<CreateServiceAccountResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/service-accounts`;
    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    await handleFailedResponse(response);
    return response.json();
  }

  async upsertServiceAccount(
    request: UpsertServiceAccountRequest,
  ): Promise<UpsertServiceAccountResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/service-accounts`;

    const response = await this.fetchApi.fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    await handleFailedResponse(response);
    return response.json();
  }

  async deleteServiceAccounts(
    request: DeleteServiceAccountRequest,
  ): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const url = new URL(`${baseUrl}/service-accounts`);

    const userRefs = Array.isArray(request.userRefs)
      ? request.userRefs
      : [request.userRefs];

    userRefs.forEach(ref => {
      url.searchParams.append('userRefs', ref);
    });

    const response = await this.fetchApi.fetch(url.toString(), {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    await handleFailedResponse(response);
  }

  async verifyServiceAccount(
    request: VerifyServiceAccountRequest,
  ): Promise<boolean> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/service-accounts/${encodeURIComponent(
      request.ref,
    )}`;

    try {
      const response = await this.fetchApi.fetch(url, {
        method: 'HEAD',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.ok;
    } catch (error) {
      return false;
    }
  }
}
